import React from 'react';
import { Slider as MuiSlider, SliderProps } from '@mui/material';

export { SliderProps };

export default function Slider(props: SliderProps) {
  let { sx, ...others } = props;
  // Examples:
  // https://mui.com/components/slider/#customization
  sx = {
    height: 22,
    '& .MuiSlider-rail': {
      color: 'grey.100',
      opacity: 1,
    },
    '& .MuiSlider-track': {
      border: 'none',
      borderTopRightRadius: 0,
      borderBottomRightRadius: 0,
      color: 'primary.light',
    },
    '& .MuiSlider-thumb': {
      height: 22,
      width: 22,
      background:
        'linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, #DEDFE3 100%), #FFFFFF',
      boxSizing: 'border-box',
      boxShadow: '-1.27079px 0px 2.54159px rgba(98, 105, 118, 0.15)',

      // &:focus, &:hover, &.Mui-active
      '&.Mui-focusVisible': {
        boxShadow: 'inherit',
      },
      '&:before': {
        display: 'none',
      },
    },
    ...(sx || {}),
  };

  return <MuiSlider sx={sx} {...others} />;
}
